import React, { useState } from "react";
import { Link } from "react-router-dom";

function EmersonMegaMenu({ menuTabs, onItemClick }) {
  const [activeTab, setActiveTab] = useState(0);

  if (!menuTabs || menuTabs.length === 0) return null;

  return (
    <div className="emerson-mega-menu-container">
      <div className="emerson-mega-menu-wrapper">
        {/* Left Column - Tabs Navigation */}
        <div className="emerson-mega-menu-tabs">
          <nav className="emerson-mega-menu-nav" role="tablist">
            {menuTabs.map((tab, index) => (
              <button
                key={tab.id}
                className={`emerson-mega-menu-tab ${
                  activeTab === index ? "active" : ""
                }`}
                onClick={() => setActiveTab(index)}
                onMouseEnter={() => setActiveTab(index)}
                role="tab"
                aria-selected={activeTab === index}
                aria-controls={`emerson-mega-menu-panel-${index}`}
                id={`emerson-mega-menu-tab-${index}`}
              >
                <span className="emerson-mega-menu-tab-text">{tab.label}</span>
                <span className="emerson-mega-menu-tab-arrow">→</span>
              </button>
            ))}
          </nav>
        </div>

        {/* Right Column - Content Panels */}
        <div className="emerson-mega-menu-content">
          {menuTabs.map((tab, index) => (
            <div
              key={tab.id}
              id={`emerson-mega-menu-panel-${index}`}
              className={`emerson-mega-menu-panel ${
                activeTab === index ? "active" : ""
              }`}
              role="tabpanel"
              aria-labelledby={`emerson-mega-menu-tab-${index}`}
            >
              <ul className="emerson-mega-menu-list">
                {tab.items.map((item, itemIndex) => (
                  <li key={itemIndex}>
                    <Link
                      to={item.link}
                      className="emerson-mega-menu-item"
                      onClick={onItemClick}
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default EmersonMegaMenu;
